import React from 'react';
import ReloadOutlined from '@ant-design/icons/ReloadOutlined';
import Button from '../button/Button';
import Spin from '../spin';
const defaultSpin = React.createElement(Spin, null);
export default function QRcodeStatus({ prefixCls, locale, onRefresh, statusRender, status, }) {
    const defaultExpiredNode = (React.createElement(React.Fragment, null,
        React.createElement("p", { className: `${prefixCls}-expired` }, locale?.expired),
        onRefresh && (React.createElement(Button, { type: "link", icon: React.createElement(ReloadOutlined, null), onClick: onRefresh }, locale?.refresh))));
    const defaultScannedNode = React.createElement("p", { className: `${prefixCls}-scanned` }, locale?.scanned);
    const defaultNodes = {
        expired: defaultExpiredNode,
        loading: defaultSpin,
        scanned: defaultScannedNode,
    };
    const defaultStatusRender = (info) => defaultNodes[info.status];
    const mergedStatusRender = statusRender ?? defaultStatusRender;
    return mergedStatusRender({
        status,
        locale,
        onRefresh,
    });
}
